<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Transaction List</h1>
        </div>
        <div class="col-sm-6 float-left add_user_btn">
            <a routerLink="/create-payment-transaction" class="btn btn-success">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Transaction
            </a>
        </div>
    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3">
                        <input class="form-control" type="text" [(ngModel)]="search_data" placeholder="Search" />
                    </div>
                    <div class="col-sm-3">
                        <mat-select placeholder="Payment Link Sent By" [(ngModel)]="userSearch"
                            (click)="setSearchValue('user')">
                            <input class="mySearchInput" #alluserSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'user')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="alluserSearch">
                            <mat-option [value]="user.id" *ngFor="let user of alluser">{{user.name}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3">
                        <mat-select placeholder="Payment Type" [(ngModel)]="payment_type">
                            <mat-option value="1">IPD</mat-option>
                            <mat-option value="2">OPD</mat-option>
                            <mat-option value="3">Health Plan</mat-option>
                            <mat-option value="4">Lab Test</mat-option>
                            <mat-option value="5">Scan Book</mat-option>
                            <mat-option value="6">Hair Removal</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3">
                        <mat-select placeholder="Status" [(ngModel)]="status_search">
                            <mat-option value="created">Created</mat-option>
                            <mat-option value="captured">Captured</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Payment Link Sent Date</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChangePaymentLink(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDatePaymentLink()">clear</mat-icon>
                    </div>
                    <div class="col-sm-3 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Payment Received Date</mat-label>
                            <mat-date-range-input [rangePicker]="picker1">
                                <input matStartDate #PaymentReceivedDateStart placeholder="Start date">
                                <input matEndDate #PaymentReceivedDateEnd placeholder="End date"
                                    (dateChange)="dateRangeChangePaymentReceived(PaymentReceivedDateStart, PaymentReceivedDateEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker1></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDatePaymentReceived()">clear</mat-icon>
                    </div>

                    <div class="col-sm-6 mt-2">
                        <button type="button" class="btn btn-primary ml-2 mt-2"
                            (click)="loadTransactionList(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i>
                            Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mt-2" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>

                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-5 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadTransactionList(0,perpage)"><i class="fa fa-sync"
                            [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                    <button type="button" class="btn btn-success ml-2" [disabled]="loading"
                        (click)="exportTransactionList()"><i class="fa fa-file-excel"></i> Export List</button>
                </div>
                <div class="col-sm-1 p-3">
                    <!-- Import Transaction -->
                        <div><a class="float-right btn btn-success text-white" (click)="showModal()"><i class="fa fa-file-excel"></i> Import Transaction </a><br></div> <br>
                        
                        <a href="{{s3url}}crm/transaction-sample-import.csv" target="_blank">Sample CSV</a>
                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped hospitalTable">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Glamyo Patient ID</th>
                            <th class="tablefixcoloumn">Name</th>
                            <th>Mobile</th>
                            <th>Payment Type</th>
                            <th>Plan Type</th>
                            <th>Amount</th>
                            <th>Payment Link ID</th>
                            <th>Payment ID</th>
                            <th>Payment Link Sent Date</th>
                            <th>Payment Received Date</th>
                            <th>Payment Link Sent By</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let transaction of transactionList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{transaction.glamyo_patient_id}} </td>
                            <td>{{transaction.lead_name}} </td>
                            <td>{{transaction.lead_mobile}} </td>
                            <td>{{transaction.payment_type}} </td>
                            <td>{{transaction.plan_type}} </td>
                            <td>{{transaction.amount}} </td>
                            <td>{{transaction.payment_link_id}} </td>
                            <td>{{transaction.payment_id}} </td>
                            <td>{{transaction.payment_link_send_date}} </td>
                            <td>{{transaction.payment_received_date}} </td>
                            <td>{{transaction.created_by}} </td>
                            <td>{{transaction.status}} </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !transactionList.length">
                            <td colspan="5"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal fade" id="myModal">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Data </h4>
          <button type="button" class="close" (click)="hideModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUpload (change)="selectFile($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModal()">Close</button>
        </div>
      </div>
    </div>
  </div>